import { useCallback } from "react";
import { toast } from "sonner";
import { CopyIcon } from "./icons";
import styles from "./copyableAddress.module.scss";

interface CopyableAddressProps {
  address: string;
  className?: string;
}

export function CopyableAddress({ address, className }: CopyableAddressProps) {
  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(address);
      toast.success("Адрес скопирован");
    } catch (error) {
      console.error("Failed to copy address:", error);
      // Fallback для старых браузеров
      const textArea = document.createElement("textarea");
      textArea.value = address;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        toast.success("Адрес скопирован");
      } catch (err) {
        console.error("Fallback copy failed:", err);
        toast.error("Не удалось скопировать адрес");
      }
      document.body.removeChild(textArea);
    }
  }, [address]);

  return (
    <div className={`${styles.container} ${className || ""}`}>
      <p className={styles.address} onClick={handleCopy}>{address}</p>
      <button
        type="button"
        onClick={handleCopy}
        className={styles.copyButton}
        aria-label="Скопировать адрес"
      >
        <CopyIcon size={14} />
      </button>
    </div>
  );
}
